import isPromise from 'is-promise';
const manager = {
    key: 1,
    config: {
        duration: 3,
        top: 24,
        bottom: 24,
        placement: 'leftBottom',
        transitionName: 'move-up',
        icons: {
            info: 'info',
            success: 'check_circle',
            error: 'error',
            warning: 'warning',
            loading: 'loading',
        },
    },
    remove(key) {
        const { instance } = this;
        if (instance) {
            if (isPromise(instance)) {
                instance.then(ins => ins.removeNotice(key));
            }
            else {
                instance.removeNotice(key);
            }
        }
    },
    clear() {
        const { instance } = this;
        if (instance) {
            if (isPromise(instance)) {
                instance.then(ins => ins.destroy());
            }
            else {
                instance.destroy();
            }
            delete this.instance;
        }
    },
    getUuid() {
        return `${this.key++}`;
    },
};
export default manager;
